var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { getWebChatUrlWithQuery, onLinkClick, onMessage, sendChatEvent, toggleBodyScroll } from './eventHandlers';
import { ChatIFrame } from './ChatIFrame';
import { Event, WidgetOpenState, WidgetState } from './types';
import { RobotIcon } from './icons/Robot';
import { isValidUrl } from './utils';
import { WidgetContainer } from './WidgetContainer';
import { ChatPreview } from './ChatPreview';
import { useFontLoader } from './hooks/useFontLoader';
import { usePartnerConfig } from './hooks/usePartnerConfig';
import { usePartnerEventsTracker } from './hooks/usePartnerEventsTracker';
var ToggleStateMap = (_a = {},
    _a[WidgetOpenState.Open] = WidgetOpenState.Closed,
    _a[WidgetOpenState.Closed] = WidgetOpenState.Open,
    _a[WidgetOpenState.Initial] = WidgetOpenState.Open,
    _a);
// eslint-disable-next-line complexity
export var Widget = function () {
    var _a, _b, _c, _d;
    var _e = useState(WidgetState.Initializing), widgetState = _e[0], setWidgetState = _e[1];
    var _f = usePartnerConfig(), partnerConfig = _f.partnerConfig, setPartnerConfig = _f.setPartnerConfig, isConfigLoaded = _f.isConfigLoaded, setConfigLoaded = _f.setConfigLoaded, hasServerConfig = _f.hasServerConfig;
    var _g = useState(0), badge = _g[0], setBadge = _g[1];
    var _h = useState(WidgetOpenState.Initial), widgetOpenState = _h[0], setWidgetOpenState = _h[1];
    var _j = useFontLoader(isConfigLoaded, partnerConfig.fonts), fontLoaded = _j.fontLoaded, fontName = _j.fontName;
    var _k = useState(false), isVisible = _k[0], setIsVisible = _k[1];
    var _l = useState(hasServerConfig), chatLoaded = _l[0], setChatLoaded = _l[1]; // when server config present, no need to wait for webapp confirmation
    var _m = useState(false), renderChatIFrame = _m[0], setRenderChatIFrame = _m[1];
    var _o = useState(false), isPreviewVisible = _o[0], setIsPreviewVisible = _o[1];
    var showChatIFrame = widgetOpenState === WidgetOpenState.Open && chatLoaded;
    var showWidgetIcon = widgetOpenState === WidgetOpenState.Initial || widgetOpenState === WidgetOpenState.Closed;
    var showChatPreview = isPreviewVisible && isVisible && showWidgetIcon && isConfigLoaded && fontLoaded;
    useEffect(function () {
        if (hasServerConfig) {
            setChatLoaded(hasServerConfig);
        }
    }, [hasServerConfig]);
    useEffect(function () {
        if (widgetOpenState === WidgetOpenState.Open) {
            setRenderChatIFrame(true);
        }
        else if (widgetOpenState === WidgetOpenState.Closed) {
            setIsPreviewVisible(false);
        }
    }, [widgetOpenState]);
    useEffect(function () {
        if (isMobile) {
            toggleBodyScroll(!showChatIFrame);
        }
    }, [showChatIFrame]);
    useEffect(function () {
        var iframe = document.getElementById('__EDDY_TRAVELS_CHAT_IFRAME');
        var messageHandler = onMessage(setWidgetOpenState, setChatLoaded, widgetOpenState, partnerConfig);
        window.addEventListener('message', messageHandler);
        var linkClickHandler = onLinkClick({
            iframe: iframe,
            partnerConfig: partnerConfig,
            onValidClick: function (_a) {
                var dl = _a.dl, send = _a.send;
                return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!!renderChatIFrame) return [3 /*break*/, 2];
                                return [4 /*yield*/, setPartnerConfig({ preview: { deeplink: dl, deeplinkText: send } })];
                            case 1:
                                _b.sent();
                                _b.label = 2;
                            case 2:
                                setWidgetOpenState(WidgetOpenState.Open);
                                return [2 /*return*/];
                        }
                    });
                });
            }
        });
        window.addEventListener('click', linkClickHandler);
        return function () {
            window.removeEventListener('message', messageHandler);
            window.removeEventListener('click', linkClickHandler);
        };
    }, [widgetOpenState, partnerConfig, widgetState, renderChatIFrame]);
    var _p = useState(getWebChatUrlWithQuery(partnerConfig)), chatUrl = _p[0], setChatUrl = _p[1];
    useEffect(function () {
        setChatUrl(getWebChatUrlWithQuery(partnerConfig));
    }, [partnerConfig]);
    // initialize widget
    useEffect(function () {
        var setConfigInitialized = function () {
            setWidgetState(WidgetState.Initialized);
        };
        window.addEventListener('__ET_THEME_INITIALIZED', setConfigInitialized);
        return function () {
            window.removeEventListener('__ET_THEME_INITIALIZED', setConfigInitialized);
        };
    }, []);
    // update widget
    useEffect(function () {
        var updatePartnerConfig = function (event) {
            setRenderChatIFrame(false);
            setIsVisible(false);
            setChatLoaded(false);
            setPartnerConfig(event.detail.partnerConfig);
            setConfigLoaded(true);
            setWidgetState(WidgetState.Updated);
        };
        // eslint-disable-next-line
        window.addEventListener('__ET_THEME_UPDATE', updatePartnerConfig);
        return function () {
            // eslint-disable-next-line
            window.removeEventListener('__ET_THEME_UPDATE', updatePartnerConfig);
        };
    }, []);
    // when theme is loaded after updating - show it
    useEffect(function () {
        if (isConfigLoaded && widgetState === WidgetState.Updated) {
            setWidgetOpenState(WidgetOpenState.Initial);
            setIsVisible(true);
            setWidgetState(WidgetState.Initialized);
        }
    }, [isConfigLoaded, widgetState]);
    // show/hide widget
    useEffect(function () {
        var setVisibility = function (event) {
            setIsVisible(event.detail.show);
        };
        // eslint-disable-next-line
        window.addEventListener('__ET_THEME_SHOW-HIDE', setVisibility);
        return function () {
            // eslint-disable-next-line
            window.removeEventListener('__ET_THEME_SHOW-HIDE', setVisibility);
        };
    }, []);
    useEffect(function () {
        if (isConfigLoaded) {
            sendChatEvent({ type: Event.WIDGET_LOADED });
        }
    }, [isConfigLoaded]);
    useEffect(function () {
        if (isConfigLoaded) {
            if (widgetOpenState === WidgetOpenState.Open) {
                setIsVisible(true);
                return;
            }
            var delay = partnerConfig.showDelaySeconds;
            if (typeof delay !== 'undefined' && delay === -1) {
                setIsVisible(false);
            }
            else if (typeof delay !== 'undefined') {
                setTimeout(function () {
                    setIsVisible(true);
                }, delay * 1000);
            }
            else {
                setIsVisible(true);
            }
        }
    }, [isConfigLoaded, widgetOpenState]);
    useEffect(function () {
        if (!isConfigLoaded) {
            return;
        }
        var delay = partnerConfig.previewDelaySeconds;
        if (widgetOpenState === WidgetOpenState.Initial) {
            if (typeof delay !== 'undefined') {
                setIsPreviewVisible(false);
                setTimeout(function () {
                    setIsPreviewVisible(true);
                }, delay * 1000);
            }
            else {
                setIsPreviewVisible(true);
            }
        }
    }, [isConfigLoaded, widgetOpenState]);
    useEffect(function () {
        if (!isConfigLoaded) {
            return;
        }
        if (isVisible) {
            sendChatEvent({ type: Event.WIDGET_DISPLAYED });
        }
        else {
            sendChatEvent({ type: Event.WIDGET_HIDDEN });
        }
    }, [isVisible, isConfigLoaded]);
    usePartnerEventsTracker({ partnerConfig: partnerConfig, isConfigLoaded: isConfigLoaded, isPreviewVisible: isPreviewVisible, isVisible: isVisible });
    var widgetIcon = null;
    if (showWidgetIcon) {
        var widgetIconUrl = ((_a = partnerConfig.icons) === null || _a === void 0 ? void 0 : _a.widgetIconUrl)
            ? (_b = partnerConfig.icons) === null || _b === void 0 ? void 0 : _b.widgetIconUrl
            : ((_c = partnerConfig.icons) === null || _c === void 0 ? void 0 : _c.botIconUrl) || partnerConfig.botIconUrl;
        widgetIconUrl = isValidUrl(widgetIconUrl) ? widgetIconUrl : undefined;
        if (widgetIconUrl) {
            widgetIcon = React.createElement("img", { src: widgetIconUrl, width: 64, height: 64, alt: "Open Chat" });
        }
        else {
            widgetIcon = React.createElement(RobotIcon, null);
        }
    }
    var onWidgetClick = function () {
        return setWidgetOpenState(function (state) {
            setBadge(0);
            var newState = ToggleStateMap[state];
            switch (newState) {
                case WidgetOpenState.Closed: {
                    sendChatEvent({ type: Event.WIDGET_CLOSED });
                    break;
                }
                case WidgetOpenState.Open: {
                    sendChatEvent({ type: Event.WIDGET_OPENED });
                    break;
                }
            }
            return newState;
        });
    };
    var additionalElementsRendered = showChatPreview || (renderChatIFrame && widgetOpenState !== WidgetOpenState.Closed);
    var flexLeft = !!((_d = partnerConfig.containerStyle) === null || _d === void 0 ? void 0 : _d.left);
    return (React.createElement(WidgetContainer, { widgetOpenState: widgetOpenState, partnerConfig: partnerConfig, visible: isVisible },
        renderChatIFrame ? (React.createElement(ChatIFrame, { widgetOpenState: widgetOpenState, partnerConfig: partnerConfig, visible: showChatIFrame, chatUrl: chatUrl })) : null,
        showChatPreview ? (React.createElement(ChatPreview, { partnerConfig: partnerConfig, onPreviewClick: onWidgetClick, onClose: function () {
                sendChatEvent({ type: Event.PREVIEW_CLOSED });
                setWidgetOpenState(WidgetOpenState.Closed);
                setTimeout(function () {
                    setBadge(2);
                }, 2000);
            }, fontName: fontName })) : null,
        React.createElement("div", { style: {
                zIndex: 2147483647,
                cursor: 'pointer',
                display: 'flex',
                right: '20px',
                justifyContent: flexLeft ? 'flex-start' : 'flex-end',
                paddingTop: '5px',
                // @ts-ignore (not web standard yet but supported by chrome/safari)
                '-webkit-tap-highlight-color': 'transparent',
                marginTop: additionalElementsRendered ? 'unset' : 'auto',
                direction: 'ltr',
                color: 'black'
            } },
            React.createElement("div", { onClick: onWidgetClick, style: { pointerEvents: 'auto', position: 'relative' }, id: "__EDDY_TRAVELS_CHAT_OPEN_BUTTON" },
                badge > 0 && widgetOpenState !== WidgetOpenState.Open ? (React.createElement("div", { style: {
                        zIndex: 2147483647,
                        position: 'absolute',
                        top: '-2px',
                        right: '-2px',
                        width: 24,
                        height: 24,
                        background: '#ff0000',
                        borderRadius: '50%',
                        border: '1px solid #fff',
                        color: '#fff',
                        lineHeight: '22px',
                        textAlign: 'center',
                        fontFamily: 'Arial, Helvetica, "Trebuchet MS", Tahoma',
                        fontWeight: 700,
                        fontSize: '14px'
                    } }, badge)) : null,
                widgetIcon))));
};
